export const ALERT_REFETCH_INTERVAL = 60 * 1000; //  1 minute
